import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css'; // Swiper styles
import 'swiper/css/autoplay'; // Autoplay styles
import 'swiper/css/pagination'; // Pagination styles
import config from '../config';

const GalleryContribution = ({ contributionImages }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex); // Updates the active index on slide change
  };

  return (
    <div className="contribution_section mb-5">
      <div className="my-5">
        <div className="contribution_wrapper">
          <div className="mb-4 text-center">
            <p className="text-white">We Ensure 100% Tranparency with your contribution</p>
          </div>
          <div className="custom_carousel">
            <Swiper
              modules={[Autoplay, Pagination]} // Register Autoplay and Pagination modules here
              spaceBetween={30}
              centeredSlides={true}
              autoplay={{
                delay: 2500, // Autoplay delay between slides in milliseconds
                disableOnInteraction: false, // Keeps autoplay running even after user interaction
              }}
              pagination={{
                clickable: true,
              }}
              onSlideChange={handleSlideChange} // Event listener to track the active slide
              className="mySwiper"
            >


              {contributionImages.map((img, index) => (
                <SwiperSlide key={index}>
                  <div className={`box ${index === activeIndex ? "active" : ""}`}>
                    <img src={img} className="img-fluid" alt={`img ${index + 1}`} onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = config.defaultImage;
                    }} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryContribution;
